import React, { useState } from "react";
import ConfiguratorOption from "../ConfiguratorOption";
import Breite from '../../images/4/reactcode/Breite';
import Tiefe from '../../images/4/reactcode/Tiefe';


interface ProductDimensionProps {
  dimensions: { width: number; depth: number };
  onUpdateDimensions: (newDimensions: { width: number; depth: number }) => void;
  productCovering: string;
}

const ProductDimensions: React.FC<ProductDimensionProps> = ({
  dimensions,
  onUpdateDimensions,
  productCovering
}) => {
  const [isEditingWidth, setIsEditingWidth] = useState(false);
  const [isEditingDepth, setIsEditingDepth] = useState(false);
  const [error, setError] = useState("");

  const isVSG = ["VSG (Verbundsicherheitsglas) klar", "VSG (Verbundsicherheitsglas) opal"].includes(productCovering);

  const maxDepth = isVSG ? 5.5 : 7;


  const handleWidthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    if (value > 14) {
      setError("Die Breite darf 14 Meter nicht überschreiten.");
    } else {
      setError("");
      onUpdateDimensions({ ...dimensions, width: value });
    }
  };

  const handleDepthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    if (value > maxDepth) {
      setError("Die Tiefe darf 7 Meter nicht überschreiten.");
    } else {
      setError("");
      onUpdateDimensions({ ...dimensions, depth: value });
    }
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 gap-4 w-full">
      {/* Width Slider */}
      <div className="flex flex-col items-center bg-gray-100 p-4 min-h-full rounded-3xl shadow-md w-full">
        <ConfiguratorOption
          title={"Breite:"}
          imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/image_dim_1.svg`}
          imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/Carport.svg`}
          onClick={() => { }}
          isSelected={false}
          SVGComponent={Breite}

        />
        <input
          type="range"
          min="0"
          max="14"
          step="0.1"
          value={dimensions?.width}
          onChange={handleWidthChange}
          className="w-full h-3 bg-gray-300 rounded-lg appearance-none focus:outline-none accent-red-600 mt-4"
        />

        <div
          className="mt-4 flex items-center justify-center w-32 h-10 bg-white text-lg sm:text-xl font-bold text-gray-900 py-2 px-4 rounded-full border-2 border-gray-300 cursor-pointer"
        >
          {isEditingWidth ? (
            <input
              type="number"
              value={dimensions?.width || ""}
              onChange={handleWidthChange}
              step="0.1"
              max={14}
              onBlur={() => setIsEditingWidth(false)}
              autoFocus
              className="w-full bg-transparent text-center outline-none border-none truncate focus:outline-none focus:ring-0"
            />
          ) : (
            <span
              onFocus={() => setIsEditingWidth(true)}
              tabIndex={0}
              className="outline-none"
            >
              {dimensions?.width || ""} m
            </span>
          )}
        </div>
      </div>

      {/* Depth Slider */}
      <div className="flex flex-col items-center bg-gray-100 p-4 rounded-3xl shadow-md w-full">
        <ConfiguratorOption
          title="Tiefe:"
          imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/image_dim_2.svg`}
          imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/Carport.svg`}
          onClick={() => { }}
          isSelected={false}
          SVGComponent={Tiefe}
        />
        <input
          type="range"
          min="0"
          max={maxDepth}
          step="0.1" // ensures smooth increments for precise floating-point values
          value={dimensions?.depth}
          onChange={handleDepthChange}
          className="w-full h-3 bg-gray-300 rounded-lg appearance-none focus:outline-none accent-red-600 mt-4"
        />

        <div
          className="mt-4 flex items-center justify-center w-32 h-10 bg-white text-lg sm:text-xl font-bold text-gray-900 py-2 px-4 rounded-full border-2 border-gray-300 cursor-pointer"
        >
          {isEditingDepth ? (
            <input
              type="number"
              value={dimensions?.depth || ""}
              onChange={handleDepthChange}
              max={maxDepth}
              step="0.1"
              onBlur={() => setIsEditingDepth(false)}
              autoFocus
              className="w-full bg-transparent text-center outline-none border-none truncate focus:outline-none focus:ring-0"
            />
          ) : (
            <span
              onFocus={() => setIsEditingDepth(true)}
              tabIndex={0}
              className="outline-none"
            >
              {dimensions?.depth || ""} m
            </span>
          )}
        </div>
      </div>
      {error && (
        <div className="col-span-2 text-center text-red-600 font-bold mt-4">
          {error}
        </div>
      )}
    </div>
  );
};

export default ProductDimensions;
